import { render, staticRenderFns } from "./AuctionDescription.vue?vue&type=template&id=0fb699af&scoped=true"
import script from "./AuctionDescription.vue?vue&type=script&lang=js"
export * from "./AuctionDescription.vue?vue&type=script&lang=js"
import style0 from "./AuctionDescription.vue?vue&type=style&index=0&id=0fb699af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb699af",
  null
  
)

export default component.exports